import useCsvExport from '../../../hooks/useCsvExport'
import { AppButton } from '../../atoms/AppButton/AppButton'

type Props = {
  onExport: () => Promise<void>
  disabled?: boolean
}

const ExportCsvButton = ({ onExport, disabled = false }: Props): JSX.Element => {
  const { exporting, error, trigger } = useCsvExport(onExport)

  return (
    <div className="flex flex-col items-end gap-2">
      <AppButton type="info" onClick={trigger} disabled={disabled || exporting}>
        {exporting ? 'Exporting…' : 'Export CSV'}
      </AppButton>
      {error && (
        <p role="alert" className="text-xl text-error-red">
          {error}
        </p>
      )}
    </div>
  )
}

export default ExportCsvButton
